module.exports = __webpack_public_path__ + "media/components/assets/bottle_02-801214ea676915f3a621c6e1564e3023.png";